import { Constants } from "@eagerdog/constants";
import { IDogClass } from "@eagerdog/interfaces";

import { IOption } from "src/components/Dropdown/Dropdown";

const workingOrCourierOptions = [
  { value: '1', id: 'leg_1' },
  { value: '2', id: 'leg_2' },
  { value: '3', id: 'leg_3' },
];

const masterOptions = [
  ...workingOrCourierOptions,
  { value: '4', id: 'leg_4' },
  { value: '5', id: 'leg_5' },
];

const getWorkingLegOptions = (dogClasses:  IDogClass[]): IOption[] => {
  const selectedClass = dogClasses[0]?.level ?? "";

  if ([Constants.dog_class_element.working, Constants.dog_class_element.courier].includes(selectedClass)) {
    return workingOrCourierOptions;
  }
  if (selectedClass === Constants.dog_class_element.master) {
    return masterOptions;
  }

  return [];
}

export { workingOrCourierOptions, masterOptions, getWorkingLegOptions }
